import { useI18n } from '../i18n';

export default function PlantIdentityPath({ category, species, variety, onCategory, onSpecies }) {
  const { t } = useI18n();
  return <nav aria-label={t('plant_picker.path')} className="rounded-xl bg-brand-bg2 border border-brand-border px-3 py-2 text-sm mb-4" data-testid="plant-identity-path">
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
      <li>{onCategory ? <button type="button" onClick={onCategory} className="min-h-11 underline">{category || t('plant_picker.choose_category')}</button> : category || t('plant_picker.choose_category')}</li>
      <li aria-hidden="true">›</li>
      <li>{onSpecies ? <button type="button" onClick={onSpecies} className="min-h-11 underline">{species || t('plant_picker.choose_species')}</button> : species || t('plant_picker.choose_species')}</li>
      {species && <><li aria-hidden="true">›</li><li aria-current="step" className="font-semibold break-words">{variety || t('plant_picker.choose_variety')}</li></>}
    </ol>
  </nav>;
}
